module.exports = __webpack_public_path__ + "./fonts/Inter-Italic.otf";